import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { BuildingType } from '../../data';

@Component({
    selector: '[app-catalog-roof]',
    templateUrl: './catalog-roof.component.html',
    styleUrl: './catalog-roof.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CatalogRoofComponent {
  type = input<BuildingType>();
}
